import Empty from './src/empty2.mjs';
export { emptyProps } from './src/empty.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElEmpty = withInstall(Empty);

export { ElEmpty, ElEmpty as default };
//# sourceMappingURL=index.mjs.map
